import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initTracking } from './utils/tracking'

// ページ表示時に即座にトラッキング初期化
// - visitor_id の生成・保存
// - UTM/アフィリエイトパラメータをsessionStorageに保存
// - 全クリック/タップイベントのGA4トラッキング設定
initTracking();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
